import { List } from 'immutable';
import { xeroMappingConstants } from '../constants';

export function xero_mappings(state = {}, action) {
  switch (action.type) {
    case xeroMappingConstants.XERO_MAPPING_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case xeroMappingConstants.XERO_MAPPING_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case xeroMappingConstants.XERO_MAPPING_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: List([]),
        listError: action.error
      };

    case xeroMappingConstants.XERO_MAPPING_LIST_CLEAR:
      return {
        ...state,
        items: null
      };

    case xeroMappingConstants.XERO_MAPPING_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case xeroMappingConstants.XERO_MAPPING_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case xeroMappingConstants.XERO_MAPPING_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case xeroMappingConstants.XERO_MAPPING_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case xeroMappingConstants.XERO_MAPPING_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const xeroMappingIndex = state.items.findIndex(val => val.id == action.response.id);

      if (xeroMappingIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(xeroMappingIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case xeroMappingConstants.XERO_MAPPING_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case xeroMappingConstants.XERO_MAPPING_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case xeroMappingConstants.XERO_MAPPING_DELETE_SUCCESS: {
      const { xeroMappingId } = action;

      if (!state.items) {
        return state;
      }

      const xeroMappingIndex = state.items.findIndex(val => val.id == xeroMappingId);

      if (xeroMappingIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(xeroMappingIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case xeroMappingConstants.XERO_MAPPING_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case xeroMappingConstants.XERO_MAPPING_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
